module.exports = __webpack_public_path__ + "static/media/john_davis.a0a5dcb7.png";